import { useMediaQuery } from './useMediaQuery';

/**
 * Single source of truth for "is this a mobile viewport" in JS. Matches the
 * Tailwind `md` breakpoint (768px) used by all mobile/desktop class toggles
 * (`md:hidden` / `hidden md:flex`), and stays in sync on resize/rotation.
 */
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 767px)');
}

/**
 * "Is the primary pointer a finger" — independent of width. The Duo's inner
 * screen runs the md+ desktop layout on touch, so touch behaviour (whole-row
 * bulk toggling, no hover-driven state) keys off this, not useIsMobile.
 */
export function useIsTouch(): boolean {
  return useMediaQuery('(hover: none)');
}
